import { DeckApiError } from './api.js';

export function isAbortError(reason: unknown): boolean {
  return reason instanceof DOMException && reason.name === 'AbortError';
}

export function deckErrorCode(reason: unknown): string | undefined {
  if (reason instanceof DeckApiError) return reason.code;
  if (typeof reason === 'object' && reason !== null && 'code' in reason
    && typeof (reason as { code?: unknown }).code === 'string') {
    return (reason as { code: string }).code;
  }
  return undefined;
}

export function deckErrorMessage(reason: unknown): string {
  switch (deckErrorCode(reason)) {
    case 'ACCOUNT_REQUIRED':
      return 'Для управления колодами нужно войти в аккаунт.';
    case 'PROFILE_INCOMPLETE':
      return 'Сначала завершите настройку профиля.';
    case 'DECK_LIMIT_REACHED':
      return 'Достигнут лимит 20 колод. Архивирование не освобождает место — удалите ненужную колоду.';
    case 'DECK_REVISION_CONFLICT':
      return 'Колода изменилась в другой вкладке или на другом устройстве.';
    case 'DECK_NOT_FOUND':
      return 'Колода не найдена или уже удалена.';
    case 'DECK_INVALID':
      return 'Состав колоды больше нельзя сохранить. Исправьте отмеченные карты.';
    case 'DECK_NAME_INVALID':
      return 'Введите название длиной от 1 до 60 символов без управляющих знаков.';
    case 'RATE_LIMITED':
      return 'Слишком много запросов. Подождите немного и попробуйте ещё раз.';
    case 'SERVICE_UNAVAILABLE':
      return 'Сервис колод временно недоступен. Попробуйте ещё раз.';
    case 'FORBIDDEN_ORIGIN':
      return 'Браузер не передал корректный источник запроса. Обновите страницу и повторите действие.';
    case 'OPERATION_ID_CONFLICT':
      return 'Запрос устарел. Обновите страницу и повторите действие.';
    default:
      return 'Не удалось выполнить действие. Попробуйте ещё раз.';
  }
}
